import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { PersonalInfoForm } from '@/components/shared/components/forms/PersonalInfoForm';
import { PersonalInfo } from '@/types';

interface ProfileDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: Omit<PersonalInfo, 'id'>) => void;
  initialData?: PersonalInfo;
  mode: 'add' | 'edit';
}

export function ProfileDialog({
  open,
  onClose,
  onSubmit,
  initialData,
  mode,
}: ProfileDialogProps) {
  const [formData, setFormData] = useState({
    fullName: initialData?.fullName || '',
    description: initialData?.description || '',
    phoneNumber: initialData?.phoneNumber || '',
    photoUrl: initialData?.photoUrl || '',
    resumeUrl: initialData?.resumeUrl || '',
    isResumePublic: initialData?.isResumePublic || false,
    forSelf: true,
    createdAt: initialData?.createdAt || Date.now(),
    updatedAt: Date.now()
  });

  useEffect(() => {
    if (initialData) {
      console.log({initialData})
      setFormData({
        fullName: initialData.fullName,
        description: initialData.description,
        phoneNumber: initialData.phoneNumber,
        photoUrl: initialData.photoUrl || '',
        resumeUrl: initialData.resumeUrl || '',
        isResumePublic: initialData.isResumePublic,
        forSelf: true,
        createdAt: initialData.createdAt,
        updatedAt: Date.now()
      });
    }
  }, [initialData]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] flex flex-col">
        <DialogHeader>
          <DialogTitle>
            {mode === 'add' ? 'إضافة من أنت' : 'تعديل الملف الشخصي'}
          </DialogTitle>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto">
          <PersonalInfoForm
            formData={formData}
            onChange={setFormData}
            onSubmit={handleSubmit}
            submitLabel={mode === 'add' ? 'إضافة' : 'حفظ التعديلات'}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}